/**
 * TG context store — exposes initialized TgLaunchContext to the entire app.
 * Initialised once at app bootstrap (main.tsx) and read via useTgContext().
 */
import { createContext, useContext } from "react";

import type { TgLaunchContext } from "@/lib/tg";

const DEFAULT_CTX: TgLaunchContext = {
  inTelegram: false,
  initData: null,
  user: null,
  colorScheme: "dark",
  platform: "web",
};

export const TgContext = createContext<TgLaunchContext>(DEFAULT_CTX);

export function useTgContext(): TgLaunchContext {
  return useContext(TgContext);
}
